import { LOADING_STATE } from "types/general";
import { IState } from "./types";

export const PORTFOLIO_SLICE_NAME = "portfolio";

export const initialState: IState = {
  selection: {
    loadingState: LOADING_STATE.idle,
  },
  dashboard: {
    loadingState: LOADING_STATE.idle,
  },
};
